import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Park bench, 1.5 m wide: two matte-black frame ends carrying three plank
// seat slats and two back slats. Sits facing +Z.
const BLACK = "#2e2e30";
const PLANK = "#c8975a";

/** One frame end (leg block + angled back post) at the given x. */
function frameEnd(x: number): Part[] {
  return [
    {
      geometry: new THREE.BoxGeometry(0.06, 0.44, 0.5),
      color: BLACK,
      position: [x, 0.22, 0.02],
    },
    {
      geometry: new THREE.BoxGeometry(0.06, 0.55, 0.07),
      color: BLACK,
      position: [x, 0.66, -0.21],
      rotation: [0.22, 0, 0],
    },
  ];
}

export const parkBench = defineModel({
  id: "park-bench",
  batchId: "modern",
  name: "Park bench",
  tags: ["modern", "outdoor", "garden", "park", "seating", "bench"],
  summary: "A slatted park bench on matte-black frame ends.",
  description:
    "A park bench of the Modern Living kit: 1.5 m wide, two matte-black " +
    "frame ends carrying three plank seat slats and two reclined back slats. " +
    "Faces +Z.",
  tiles: { w: 2, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    const parts: Part[] = [...frameEnd(-0.7), ...frameEnd(0.7)];
    // Seat slats.
    for (const z of [0.13, -0.03, -0.19]) {
      parts.push({
        geometry: new THREE.BoxGeometry(1.5, 0.045, 0.13),
        color: PLANK,
        position: [0, 0.465, z + 0.06],
      });
    }
    // Back slats, reclined with the posts.
    for (const y of [0.62, 0.8]) {
      parts.push({
        geometry: new THREE.BoxGeometry(1.5, 0.14, 0.045),
        color: PLANK,
        position: [0, y, -0.2 + (0.71 - y) * 0.22],
        rotation: [0.22, 0, 0],
      });
    }
    return parts;
  },
  animations: [],
});
